<app-protocolo-pesquisa
    [textoBotaoEnvio]="textoBotaoEnvio"
    [tooltipBotaoEnvio]="tooltipBotaoEnvio"
    [routerLinkEnvioLote]="['/recuperacoes-credito/lote/envio']"
    [tiposConteudo]="tiposConteudo" 
></app-protocolo-pesquisa>